import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import NodeResolverSpotlightTarget from './node-resolver-spotlight-target';
import { TargetConsumer } from './spotlight-manager';
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */
var SpotlightTarget = function SpotlightTarget(_ref) {
  var children = _ref.children,
    name = _ref.name;
  return /*#__PURE__*/React.createElement(TargetConsumer, null, function (targetRef) {
    return targetRef ? /*#__PURE__*/React.createElement(NodeResolverSpotlightTarget, {
      name: name,
      hasNodeResolver: !fg('platform-design-system-dsp-20262-spotlight-target'),
      targetRef: targetRef
    }, /*#__PURE__*/React.createElement(React.Fragment, null, children)) : children;
  });
};
export default SpotlightTarget;